import {getJobsCollectionName, JobDb} from '@cp/model';
import {collection, CollectionReference} from 'firebase/firestore';
import {env} from '../../config/env';
import {firebaseFirestore} from '../../config/firebase';

export default function getJobsCollectionRef(): CollectionReference<JobDb> {
  return collection(firebaseFirestore, getJobsCollectionName(env.isDev)) as CollectionReference<JobDb>;
}
